import React from 'react';
import starSvg from '../assets/newStar.svg';

export default function Star({ width, boxwidth, boxheight, bgColor, half, halfStar, cursor }) {
  return (
    <div className={`relative flex-none flex justify-center items-center overflow-hidden rounded-full ${boxheight || "h-[33px]"} ${boxwidth || "w-[33px]"} ${cursor}`}>
      
      {/* THE ONLY LAYER: Using a clip-path to prevent border-bleeding */}
      <div 
        className={`absolute inset-0 ${half ? halfStar : (bgColor || 'bg-gray-300')}`} 
        style={half ? { clipPath: 'inset(0 50% 0 0)' } : {}}
      />

      {/* THE GRAY FILL: Only active for the right half */}
      {half && (
        <div 
          className="absolute inset-0 bg-gray-300" 
          style={{ clipPath: 'inset(0 0 0 50%)' }}
        />
      )}
      
      {/* THE STAR IMAGE */}
      <img 
        className={`${width || "w-[24px]"} h-auto block relative z-10`} 
        src={starSvg} 
        alt="star" 
      />
    </div>
  );
}